module.exports = __webpack_public_path__ + "img/fca13-en.35d990bb.png";